export default __webpack_public_path__ + "static/media/scooter-prodcutos-4-mb@2x.26029645.jpg";